export default "__VITE_ASSET__BHe9xppb__"